// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatBot Component Styles */

.chatbot-container {
  display: flex;
  height: 93vh;
  background: var(--app-bg);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  overflow: hidden;
  margin: 0 auto;
}

/* Page-specific variations */
.self-monitoring-chatbot {
  height: calc(100vh - 40px);
  margin: 20px auto;
}

.data-analysis-chatbot {
  height: calc(100vh - 200px);
  margin: 0;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* Sidebar Styles */
.chatbot-sidebar {
  width: 300px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  color: white;
}

.sidebar-header {
  padding: 24px 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.clear-chat-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 6px;
  padding: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clear-chat-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.recent-chats-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
}

.no-chats {
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin-top: 40px;
  font-size: 14px;
}

.recent-chat-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.recent-chat-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.chat-question {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 500;
  color: white;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.chat-timestamp {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

/* Main Chat Area */
.chatbot-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: var(--surface);
}

/* Header Styles */
.chatbot-header {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 24px 32px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chatbot-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.chatbot-subtitle {
  margin: 0;
  font-size: 16px;
  color: var(--text-muted);
  font-weight: 400;
}

.header-info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 12px;
}

.file-info, .session-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--surface-3);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  color: var(--text-muted);
  border: 1px solid var(--border);
}

.info-item svg {
  opacity: 0.7;
}

/* Messages Area */
.chatbot-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 32px;
  background: var(--app-bg);
  scroll-behavior: smooth;
}

.message-container {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
}

.user-message-container {
  align-items: flex-end;
}

.bot-message-container {
  align-items: flex-start;
}

.message {
  max-width: 75%;
  padding: 16px 20px;
  border-radius: 16px;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.user-message {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-bottom-right-radius: 4px;
}

.bot-message {
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
  border-bottom-left-radius: 4px;
  text-align: left;
}

.message-timestamp {
  font-size: 11px;
  color: var(--text-subtle);
  margin-top: 4px;
  padding: 0 4px;
}

.loading-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text-muted);
  font-size: 14px;
  min-height: 20px;
}

.loading-spinner {
  color: #667eea !important;
}

/* Response Type Styles */
.text-response {
  line-height: 1.6;
  text-align: left;
}

/* Keep loading message compact */
.loading-message {
  display: inline-flex;
  padding: 8px 12px;
  height: auto;
  max-height: 48px;
  width: auto;
  align-items: center;
  overflow: hidden;
}

.text-response h1, .text-response h2, .text-response h3 {
  margin: 0 0 12px 0;
  color: inherit;
}

.text-response p {
  margin: 0 0 8px 0;
}

.text-response ul, .text-response ol {
  margin: 8px 0;
  padding-left: 20px;
}

.table-response {
  margin: 16px 0;
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
}

.table-response .ant-table-wrapper {
  width: 100%;
  overflow: visible;
}

.table-response .ant-table {
  width: 100%;
  overflow: visible;
}

.table-response .ant-table-content {
  overflow-x: auto;
  width: 100%;
}

.chatbot-table .ant-table {
  background: var(--surface);
}

.chatbot-table .ant-table-thead > tr > th {
  background: var(--surface-2);
  border-bottom: 2px solid var(--border);
  font-weight: 600;
  color: var(--text);
}

.chatbot-table .ant-table-tbody > tr:hover > td {
  background: var(--surface-hover);
}

.plotly-response {
  margin: 16px 0;
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: var(--surface);
  width: 100%;
  min-height: 400px;
}

.plotly-chart {
  border-radius: 8px;
  width: 100% !important;
  height: auto !important;
  min-height: 400px !important;
}

.plotly-chart .plotly {
  width: 100% !important;
  height: 100% !important;
}

.plotly-chart .main-svg {
  width: 100% !important;
  height: 100% !important;
}

/* Input Form */
.chatbot-input-form {
  padding: 20px 32px 24px;
  background: var(--surface);
  border-top: 1px solid var(--border);
}

.input-container {
  display: flex;
  gap: 12px;
  align-items: center;
  background: var(--surface-2);
  border: 2px solid var(--border);
  border-radius: 24px;
  padding: 4px;
  transition: all 0.2s ease;
}

.input-container:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.chatbot-file-input {
  display: none;
}

.chatbot-attach-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-left: 4px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.chatbot-attach-button:hover:not(:disabled) {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.chatbot-attach-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chatbot-input {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 16px;
  color: var(--text);
  outline: none;
  resize: none;
}

.chatbot-input::placeholder {
  color: var(--text-subtle);
}

.send-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 20px;
  padding: 12px 16px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
}

.send-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design — desktop heights/layout above unchanged */
@media (max-width: 768px) {
  .chatbot-container,
  .kedb-chat,
  .wsa-chat,
  .self-monitoring-chatbot,
  .data-analysis-chatbot {
    height: calc(100dvh - 88px);
    max-height: calc(100dvh - 88px);
    border-radius: 12px;
    margin: 0;
    width: 100%;
    max-width: 100% !important;
  }

  .chatbot-sidebar {
    width: 250px;
  }

  .chatbot-header {
    padding: 14px 16px;
  }

  .chatbot-title {
    font-size: 1.125rem;
  }

  .chatbot-subtitle {
    font-size: 0.8125rem;
  }

  .chatbot-main {
    min-width: 0;
    width: 100%;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .chatbot-messages {
    padding: 14px 16px;
    flex: 1 1;
    min-height: 0;
  }

  .input-container {
    min-width: 0;
    flex: 1 1;
  }

  .chatbot-input {
    min-width: 0;
    font-size: 16px; /* prevent iOS zoom on focus */
  }

  .message {
    max-width: 85%;
    padding: 12px 14px;
  }

  .chatbot-input-form {
    padding: 12px 16px;
    padding-bottom: max(12px, env(safe-area-inset-bottom));
  }
}

@media (max-width: 640px) {
  .chatbot-container,
  .kedb-chat,
  .wsa-chat,
  .self-monitoring-chatbot,
  .data-analysis-chatbot {
    flex-direction: column;
    border-radius: 10px;
    height: calc(100dvh - 88px);
    max-height: calc(100dvh - 88px);
  }

  .chatbot-sidebar {
    width: 100%;
    height: auto;
    max-height: 160px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }

  .header-info {
    flex-direction: column;
    gap: 8px;
  }

  .file-info, .session-info {
    justify-content: flex-start;
  }

  .message {
    max-width: 95%;
  }
}

/* Scrollbar Styles */
.chatbot-messages::-webkit-scrollbar,
.recent-chats-list::-webkit-scrollbar {
  width: 6px;
}

.chatbot-messages::-webkit-scrollbar-track,
.recent-chats-list::-webkit-scrollbar-track {
  background: var(--surface-3);
  border-radius: 3px;
}

.chatbot-messages::-webkit-scrollbar-thumb,
.recent-chats-list::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 3px;
}

.chatbot-messages::-webkit-scrollbar-thumb:hover,
.recent-chats-list::-webkit-scrollbar-thumb:hover {
  background: var(--text-subtle);
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatBot/styles.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yGAAyG;EACzG,iFAAiF;EACjF,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,6DAA6D;EAC7D,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE;;;;;IAKE,2BAA2B;IAC3B,+BAA+B;IAC/B,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAO;IACP,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,SAAO;EACT;;EAEA;IACE,YAAY;IACZ,eAAe,EAAE,8BAA8B;EACjD;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sDAAsD;EACxD;AACF;;AAEA;EACE;;;;;IAKE,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kDAAkD;EACpD;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,qBAAqB;AACrB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC","sourcesContent":["/* ChatBot Component Styles */\n\n.chatbot-container {\n  display: flex;\n  height: 93vh;\n  background: var(--app-bg);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n/* Page-specific variations */\n.self-monitoring-chatbot {\n  height: calc(100vh - 40px);\n  margin: 20px auto;\n}\n\n.data-analysis-chatbot {\n  height: calc(100vh - 200px);\n  margin: 0;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n/* Sidebar Styles */\n.chatbot-sidebar {\n  width: 300px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  color: white;\n}\n\n.sidebar-header {\n  padding: 24px 20px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.clear-chat-btn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 6px;\n  padding: 8px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.clear-chat-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.recent-chats-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n.no-chats {\n  color: rgba(255, 255, 255, 0.7);\n  text-align: center;\n  margin-top: 40px;\n  font-size: 14px;\n}\n\n.recent-chat-item {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.recent-chat-item:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-1px);\n}\n\n.chat-question {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.chat-timestamp {\n  margin: 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Main Chat Area */\n.chatbot-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface);\n}\n\n/* Header Styles */\n.chatbot-header {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 24px 32px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n}\n\n.header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chatbot-title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a202c;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.chatbot-subtitle {\n  margin: 0;\n  font-size: 16px;\n  color: var(--text-muted);\n  font-weight: 400;\n}\n\n.header-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.file-info, .session-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--surface-3);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  color: var(--text-muted);\n  border: 1px solid var(--border);\n}\n\n.info-item svg {\n  opacity: 0.7;\n}\n\n/* Messages Area */\n.chatbot-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 32px;\n  background: var(--app-bg);\n  scroll-behavior: smooth;\n}\n\n.message-container {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-message-container {\n  align-items: flex-end;\n}\n\n.bot-message-container {\n  align-items: flex-start;\n}\n\n.message {\n  max-width: 75%;\n  padding: 16px 20px;\n  border-radius: 16px;\n  word-wrap: break-word;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.user-message {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.bot-message {\n  background: var(--surface);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-bottom-left-radius: 4px;\n  text-align: left;\n}\n\n.message-timestamp {\n  font-size: 11px;\n  color: var(--text-subtle);\n  margin-top: 4px;\n  padding: 0 4px;\n}\n\n.loading-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-muted);\n  font-size: 14px;\n  min-height: 20px;\n}\n\n.loading-spinner {\n  color: #667eea !important;\n}\n\n/* Response Type Styles */\n.text-response {\n  line-height: 1.6;\n  text-align: left;\n}\n\n/* Keep loading message compact */\n.loading-message {\n  display: inline-flex;\n  padding: 8px 12px;\n  height: auto;\n  max-height: 48px;\n  width: auto;\n  align-items: center;\n  overflow: hidden;\n}\n\n.text-response h1, .text-response h2, .text-response h3 {\n  margin: 0 0 12px 0;\n  color: inherit;\n}\n\n.text-response p {\n  margin: 0 0 8px 0;\n}\n\n.text-response ul, .text-response ol {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.table-response {\n  margin: 16px 0;\n  border-radius: 8px;\n  overflow: visible;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 100%;\n}\n\n.table-response .ant-table-wrapper {\n  width: 100%;\n  overflow: visible;\n}\n\n.table-response .ant-table {\n  width: 100%;\n  overflow: visible;\n}\n\n.table-response .ant-table-content {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.chatbot-table .ant-table {\n  background: var(--surface);\n}\n\n.chatbot-table .ant-table-thead > tr > th {\n  background: var(--surface-2);\n  border-bottom: 2px solid var(--border);\n  font-weight: 600;\n  color: var(--text);\n}\n\n.chatbot-table .ant-table-tbody > tr:hover > td {\n  background: var(--surface-hover);\n}\n\n.plotly-response {\n  margin: 16px 0;\n  border-radius: 8px;\n  overflow: visible;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background: var(--surface);\n  width: 100%;\n  min-height: 400px;\n}\n\n.plotly-chart {\n  border-radius: 8px;\n  width: 100% !important;\n  height: auto !important;\n  min-height: 400px !important;\n}\n\n.plotly-chart .plotly {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.plotly-chart .main-svg {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Input Form */\n.chatbot-input-form {\n  padding: 20px 32px 24px;\n  background: var(--surface);\n  border-top: 1px solid var(--border);\n}\n\n.input-container {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  background: var(--surface-2);\n  border: 2px solid var(--border);\n  border-radius: 24px;\n  padding: 4px;\n  transition: all 0.2s ease;\n}\n\n.input-container:focus-within {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.chatbot-file-input {\n  display: none;\n}\n\n.chatbot-attach-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  margin-left: 4px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.chatbot-attach-button:hover:not(:disabled) {\n  color: #667eea;\n  background: rgba(102, 126, 234, 0.1);\n}\n\n.chatbot-attach-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chatbot-input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 12px 16px;\n  font-size: 16px;\n  color: var(--text);\n  outline: none;\n  resize: none;\n}\n\n.chatbot-input::placeholder {\n  color: var(--text-subtle);\n}\n\n.send-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  border-radius: 20px;\n  padding: 12px 16px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  height: 48px;\n}\n\n.send-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.send-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design — desktop heights/layout above unchanged */\n@media (max-width: 768px) {\n  .chatbot-container,\n  .kedb-chat,\n  .wsa-chat,\n  .self-monitoring-chatbot,\n  .data-analysis-chatbot {\n    height: calc(100dvh - 88px);\n    max-height: calc(100dvh - 88px);\n    border-radius: 12px;\n    margin: 0;\n    width: 100%;\n    max-width: 100% !important;\n  }\n\n  .chatbot-sidebar {\n    width: 250px;\n  }\n\n  .chatbot-header {\n    padding: 14px 16px;\n  }\n\n  .chatbot-title {\n    font-size: 1.125rem;\n  }\n\n  .chatbot-subtitle {\n    font-size: 0.8125rem;\n  }\n\n  .chatbot-main {\n    min-width: 0;\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .chatbot-messages {\n    padding: 14px 16px;\n    flex: 1;\n    min-height: 0;\n  }\n\n  .input-container {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .chatbot-input {\n    min-width: 0;\n    font-size: 16px; /* prevent iOS zoom on focus */\n  }\n\n  .message {\n    max-width: 85%;\n    padding: 12px 14px;\n  }\n\n  .chatbot-input-form {\n    padding: 12px 16px;\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n  }\n}\n\n@media (max-width: 640px) {\n  .chatbot-container,\n  .kedb-chat,\n  .wsa-chat,\n  .self-monitoring-chatbot,\n  .data-analysis-chatbot {\n    flex-direction: column;\n    border-radius: 10px;\n    height: calc(100dvh - 88px);\n    max-height: calc(100dvh - 88px);\n  }\n\n  .chatbot-sidebar {\n    width: 100%;\n    height: auto;\n    max-height: 160px;\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  }\n\n  .header-info {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .file-info, .session-info {\n    justify-content: flex-start;\n  }\n\n  .message {\n    max-width: 95%;\n  }\n}\n\n/* Scrollbar Styles */\n.chatbot-messages::-webkit-scrollbar,\n.recent-chats-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chatbot-messages::-webkit-scrollbar-track,\n.recent-chats-list::-webkit-scrollbar-track {\n  background: var(--surface-3);\n  border-radius: 3px;\n}\n\n.chatbot-messages::-webkit-scrollbar-thumb,\n.recent-chats-list::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 3px;\n}\n\n.chatbot-messages::-webkit-scrollbar-thumb:hover,\n.recent-chats-list::-webkit-scrollbar-thumb:hover {\n  background: var(--text-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
